import React, {useContext, useEffect} from "react";
import {ATab, ATabGroup} from "@cisco-sbg-ui/magna-react";
import {Link, useLocation} from "react-router-dom";
import {sendIncidentDetailsTabsTelemetry} from "api/telemetry/incidentsTelemetrics";
import {IncidentDetailContext} from "../../contexts/IncidentDetailContext";

const IncidentDetailTabs = () => {
  const {tabData, activeTab, setActiveTab} = useContext(IncidentDetailContext);

  const location = useLocation();
  const tabFromUrl = location.pathname.split("/")[3];

  useEffect(() => {
    const routeFromURL = tabData.find((t) => t.route === tabFromUrl);
    setActiveTab(routeFromURL ? routeFromURL : tabData[0]);
  }, [activeTab]);

  return (
    <ATabGroup data-testid={"IncidentDetailTabs-TabGroup"}>
      {tabData.map((tab) => (
        <Link
          key={`tab-${tab.title}`}
          to={tab.route}
          onClick={() => {
            setActiveTab(tab);
            sendIncidentDetailsTabsTelemetry(tab.route.toUpperCase());
          }}
          style={{all: "unset"}} // resets magna styled set for all "a" elements
        >
          <ATab tabKey={tab.route} selected={activeTab === tab}>
            {tab.title}
          </ATab>
        </Link>
      ))}
    </ATabGroup>
  );
};

export default IncidentDetailTabs;
